module.exports = __webpack_public_path__ + "static/media/webased-logo2-transp-white.a53440b6.png";